import {Component} from '@angular/core';
import {AppRoutes} from "../../../enums/routes";
import {PermissionService} from "../../../_auth/permission.service";
import {LegalRoutes} from "../_models/_enums/LegalRoutes";
import {
  NavbarItemLargeComponent
} from "../../../x-components/navbar-base/navbar-item-large/navbar-item-large.component";
import {NavbarContainerComponent} from "../../../x-components/navbar-base/navbar-container/navbar-container.component";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-navbar-legal',
  templateUrl: './navbar-legal.component.html',
  imports: [
    CommonModule,
    NavbarItemLargeComponent,
    NavbarContainerComponent
  ],
  styleUrls: ['./navbar-legal.component.scss']
})
export class NavbarLegalComponent {
  protected readonly Routes = AppRoutes;
  protected readonly LegalRoutes = LegalRoutes;

  constructor(public PermissionService: PermissionService) {
  }
}
